import { get } from 'lodash';
import {
	BAD_REQUEST,
	CONFLICT,
	INTERNAL_SERVER_ERROR,
	UNAUTHORIZED,
	CREATED,
	ACCEPTED,
	OK,
	FORBIDDEN,
} from 'http-status-codes';

import {
	DAILY_LIMIT_ERROR_CODE,
	MISSED_DEADLINE_ERROR_CODE,
	TRANSACTION_LIMIT_ERROR_CODE,
	CUSTOMER_DEVICE_ENROLLED_ERROR_CODE,
	readTimeOut,
	REPEATING_PAYMENT_LIMIT_ERROR_CODE,
} from '../config';

export const getErrorCode = (apiResponse) => get(apiResponse, 'body.error.code', '');
export const isConflictError = (apiResponse) => get(apiResponse, 'code', 0) === CONFLICT;
export const isSuccessCode = (code) => [OK, ACCEPTED].includes(code);
// Multipart checks
export const getApiResponses = (action) => get(action, 'payload.apiResponses', []);
export const hasConflictError = (responses) => responses.some((response) => response.code === CONFLICT);
export const getConflictResponse = (responses) => responses.find((response) => response.code === CONFLICT);
export const hasServerError = (responses) => responses.some((response) => response.code === INTERNAL_SERVER_ERROR);
export const hasMissedDeadlineError = (apiResponses) =>
	apiResponses.some((response) => getErrorCode(response) === MISSED_DEADLINE_ERROR_CODE);
export const isMaxTransactionLimitError = (apiResponse) => getErrorCode(apiResponse) === TRANSACTION_LIMIT_ERROR_CODE;
export const isDailyLimitError = (apiResponse) => getErrorCode(apiResponse) === DAILY_LIMIT_ERROR_CODE;

// Individual response checks
export const isConflictAndDailyLimitError = (apiResponse) =>
	isDailyLimitError(apiResponse) && isConflictError(apiResponse);
export const isConflictAndMaxTransactionLimitError = (apiResponse) =>
	isMaxTransactionLimitError(apiResponse) && isConflictError(apiResponse);
export const isConflictAndMaxTransactionLimitOrDailyLimitError = (apiResponse) =>
	(isMaxTransactionLimitError(apiResponse) || isDailyLimitError(apiResponse)) && isConflictError(apiResponse);

// Action / payload status checks
export const isBadRequestStatus = (action) => get(action, 'payload.status', 0) === BAD_REQUEST;
export const isConflictStatus = (action) => get(action, 'payload.status', 0) === CONFLICT;
export const isUnauthorisedStatus = (action) => get(action, 'payload.status', 0) === UNAUTHORIZED;
export const isForbidden = (action) => get(action, 'payload.status', 0) === FORBIDDEN;
export const isServerErrorStatus = (action) => get(action, 'payload.status', 0) === INTERNAL_SERVER_ERROR;
export const isReadTimeOutStatus = (action) => {
	const responseErrorMsg = get(action, 'payload.response.message', '').toLowerCase();
	return isServerErrorStatus(action) && !!responseErrorMsg && !!responseErrorMsg.indexOf(readTimeOut) > -1;
};

// Action Response Error Codes
export const isCustomerDeviceErrorResponse = (action) =>
	get(action, 'payload.response.error.code', 0) === CUSTOMER_DEVICE_ENROLLED_ERROR_CODE;
export const isDailyLimitErrorResponse = (action) =>
	get(action, 'payload.response.error.code', 0) === DAILY_LIMIT_ERROR_CODE;
export const isMaxTransactionLimitErrorResponse = (action) =>
	get(action, 'payload.response.error.code', 0) === TRANSACTION_LIMIT_ERROR_CODE;
export const isRepeatingPaymentLimitErrorResponse = (action) =>
	get(action, 'payload.response.error.code', 0) === REPEATING_PAYMENT_LIMIT_ERROR_CODE;
export const isDailyLimitOrCustomerDeviceError = (action) =>
	(isConflictStatus(action) && isDailyLimitErrorResponse(action)) || isCustomerDeviceErrorResponse(action);

export const isMultiPartFailure = (action) => {
	const responses = getApiResponses(action);
	const hasFailure = responses.some((response) => response.code === INTERNAL_SERVER_ERROR);
	return { hasFailure, responses };
};
export const hasBeneficiaryFailed = (apiResponse) => ![ACCEPTED, CREATED].includes(get(apiResponse, 'code', 0));
